var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFormEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 65,
    viewBox: "0 0 79 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 46,
    height: 54,
    rx: 2,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2313 4.0752H17.4313C16.52 4.0752 15.7812 4.81393 15.7812 5.7252V57.4252C15.7812 58.3365 16.52 59.0752 17.4313 59.0752H59.2313C60.1425 59.0752 60.8813 58.3365 60.8813 57.4252V5.7252C60.8813 4.81393 60.1425 4.0752 59.2313 4.0752Z",
    fill: "white",
    stroke: "#868995",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0767,
    y: 23.7041,
    width: 32.5893,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0764,
    y: 31.1104,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5933,
    y: 31.1104,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0764,
    y: 37.0361,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5933,
    y: 37.0361,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0764,
    y: 42.9609,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5933,
    y: 42.9609,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0764,
    y: 48.8867,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5933,
    y: 48.8867,
    width: 14.0727,
    height: 2.96267,
    rx: 0.379516,
    fill: "white",
    stroke: "#E4E4E5",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1145 18.5186H53.9145",
    stroke: "#BEBEC1",
    strokeWidth: 2.65661,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1145 11.1123H34.6645",
    stroke: "#BEBEC1",
    strokeWidth: 2.65661,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43872 60.5039H72.1158",
    stroke: "#E4E4E5",
    strokeWidth: 1.19557,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5068 64H59.7449",
    stroke: "#E4E4E5",
    strokeWidth: 1.19557,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6499 60.5039H78.0001",
    stroke: "#E4E4E5",
    strokeWidth: 1.19557,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30615 60.5039H3.65045",
    stroke: "#E4E4E5",
    strokeWidth: 1.19557,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5039H1.3443",
    stroke: "#E4E4E5",
    strokeWidth: 1.19557,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFormEmpty);
export default __webpack_public_path__ + "static/media/web-form-empty.319eb17f.svg";
export { ForwardRef as ReactComponent };